import { BaseEntity, BaseSearchForm } from 'entities'
import { Institution } from './institution'

export const DISCOUNT_KIND = ['fixed', 'volume', 'trial']
export type DiscountKind = typeof DISCOUNT_KIND[number]
export const DISCOUNT_KIND_JP = ['固定', 'ボリューム', 'トライアル']
export const DISCOUNT_KIND_SELECT_ITEMS = DISCOUNT_KIND.map((value, index) => {
    return { label: DISCOUNT_KIND_JP[index], value: value }
})

export type Discount = BaseEntity & {
    name?: string
    kind?: DiscountKind
    ratio?: number
    value?: number
    amount?: number
    monthPeriod?: number
}

export type DiscountForm = Discount

export type DiscountSearchForm = BaseSearchForm & Discount

export type DiscountInstitution = {
    discount?: Discount
    institution?: Institution
    discountId?: number
    institutionId?: number
    expiryStartDate?: string
    expiryEndDate?: string
}
